module.exports = __webpack_public_path__ + "static/media/march2025-3.d19fe2aa.webp";